<template>
  <section class="form-list">
    <el-form
      class="form"
      ref="form"
      :rules="rules"
      :model="card"
      label-position="right"
      label-width="160px"
    >

      <el-form-item label="适用门店">
        <v-select-store
          class="w100"
          v-model="card.store_ids"
          :multiple="true"
          :is-location-limit="true"
          placeholder="全国通用"
        />
      </el-form-item>

      <template v-if="cardTypeInfo.length && card.store_ids.length">
        <el-form-item
          label="适用门店限制天数"
          prop="store_limit_expire_days"
        >
          <v-input-number
            class="w100"
            placeholder="请输入适用门店限制天数，超过该天数后课卡将自动恢复全国通用"
            type="unsignedSmallInt"
            v-model="card.store_limit_expire_days"
          />
        </el-form-item>

        <el-form-item
          label="适用门店失效日期"
          prop="store_limit_expire_time"
        >
          <el-date-picker
            v-model="card.store_limit_expire_time"
            :picker-options="pickerOptions"
            align="right"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            placeholder="开卡后系统将根据限制天数自动计算出过期时间"
            class="date-picker"
            value-format="timestamp"
            style="width: 100%"
          />
        </el-form-item>
      </template>

      <el-form-item label="课卡类型" prop="card_charge_type_id">
        <v-cascader-card-type
          v-model="cardTypeInfo"
          :store-ids="card.store_ids"
          @change="handleCardTypeChange"
        />
      </el-form-item>

      <template v-if="cardTypeInfo.length">
        <el-form-item label="禁止预约专栏">
          <span v-if="card.is_disable_column" class="danger-color">是</span>
          <span v-else class="success-color">否</span>
        </el-form-item>

        <el-form-item
          label="有效次数"
          prop="expire_number"
        >
          <v-input-money
            v-if="card.is_number_limit"
            class="w100"
            placeholder="每次预约课程后有效次数将递减，为 0 时不可继续使用"
            v-model="card.expire_number"
          />
          <span v-else class="success-color">期限卡，无次数限制</span>
        </el-form-item>

        <el-form-item
          label="有效天数"
          prop="expire_days"
        >
          <v-input-number
            class="w100"
            placeholder="开卡后系统将根据有效天数自动计算出失效日期"
            type="unsignedSmallInt"
            v-model="card.expire_days"
          />
        </el-form-item>

        <el-form-item
          label="失效日期"
          prop="expire_time"
        >
          <el-date-picker
            v-model="card.expire_time"
            :picker-options="pickerOptions"
            align="right"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            placeholder="选择日期时间"
            class="date-picker"
            value-format="timestamp"
            style="width: 100%"
          />
        </el-form-item>

      </template>
      <el-form-item label="所补差价" prop="actual_payment">
        <v-input-money
          class="w100"
          placeholder="请输入此次修改所补的差价，退款填写为负数即可"
          type="int"
          v-model="card.update_payment"
          :is-show-suffix="true"
        />
      </el-form-item>
      <el-form-item v-if="+card.update_payment !== 0" label="补差价方式" prop="update_payment_mode">
        <v-select-card-payment-mode
          class="w100"
          v-model="card.update_payment_mode"
        />
      </el-form-item>
      <el-form-item v-if="!isAdministrator" label="修改原因" prop="update_remark">
        <el-input
          v-model="card.update_remark"
          placeholder="请输入修改课卡的原因"
          maxlength="255"
        />
      </el-form-item>
      <el-form-item>
        <router-link v-if="card.card_del_apply_id" class="button-margin" :to="RouteConfig.cardDeleteApplyDetail.to(card.card_del_apply_id)">
          <el-button type="primary">退卡申请审核中，点击查看</el-button>
        </router-link>
        <router-link v-else-if="card.card_update_apply_id" class="button-margin" :to="RouteConfig.cardUpdateApplyDetail.to(card.card_update_apply_id)">
          <el-button type="primary">课卡修改审核中，点击查看</el-button>
        </router-link>
        <el-button v-else-if="card.is_reviewing" class="button-margin" :disabled="true" type="primary">修改申请审核中</el-button>
        <el-button v-else class="button-margin" :loading="isSaving" type="primary" @click="handleSubmit">
          {{ isAdministrator ? '保存' : '申请' }}修改
        </el-button>
        <el-button @click="RouteConfig.cardList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import handleCardTypeChange from '@/utils/handleCardTypeChange';
import { mapGetters } from 'vuex';
import { show, updateType } from '@/api/card';
import { storeType } from '@/api/card-update-apply';
import { toCent, toMillisecond, toSecond, toYuan } from "@/filters";
import cardPaymentModeIds from "@/enums/cardPaymentModeIds";

export default {
  name: RouteConfig.cardEditType.name,
  data: () => ({
    RouteConfig,
    isSaving: false,
    cardTypeInfo: [],
    card: {
      store_ids: [],
      card_type_id: 0,
      card_type_name: '',
      card_name: '',
      card_charge_type_id: '',
      is_number_limit: 0,
      expire_number: '',
      expire_days: '',
      expire_time: '',
      store_limit_expire_days: '',
      store_limit_expire_time: '',
      update_remark: '',
      update_payment: '',
      is_reviewing: 0,
      card_del_apply_id: 0,
      card_update_apply_id: 0,
      update_payment_mode: 0,
      is_disable_column: 0,
    },
    rules: {
      card_charge_type_id: [{ required: true, message: '请选择课卡类型', trigger: 'change' }],
      update_remark: [{ required: true, message: '请输入修改课卡的原因', trigger: 'change' }],
      update_payment_mode: [{ required: true, message: '请选择补差价付款方式', trigger: 'change' }],
    },
    pickerOptions: {
      disabledDate: (time) => time.getTime() < 0,
    },
    cardPaymentModeIds,
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
    id() {
      return +this.$route.params.id || 0;
    },
  },
  beforeMount() {
    this.show();
  },
  methods: {
    handleCardTypeChange(cardTypeInfo) {
      handleCardTypeChange(cardTypeInfo, this.card);
    },
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        const card = { ...this.card };
        card.card_id = this.id;
        card.expire_time = toSecond(card.expire_time);
        card.expire_number = toCent(card.expire_number);
        card.store_limit_expire_time = toSecond(card.store_limit_expire_time);
        card.update_payment = toCent(card.update_payment);

        this.isSaving = true;
        const { isError } = this.isAdministrator
          ? await updateType(this.id, card)
          : await storeType(card);
        this.isSaving = false;

        if (!isError) this.isAdministrator ? RouteConfig.cardList.back() : RouteConfig.cardUpdateApplyList.push();
      });
    },
    async show() {
      const { isError, data } = await show(this.id);
      if (isError) return;

      data.expire_time = toMillisecond(data.expire_time) || '';
      data.store_limit_expire_time = toMillisecond(data.store_limit_expire_time) || '';
      data.expire_number = toYuan(data.expire_number);

      const { card } = this;
      const updateCardInfo = {};
      Object.keys(data).forEach(key => {
        if (key in card) updateCardInfo[key] = data[key];
      });
      Object.assign(card, updateCardInfo);
      this.cardTypeInfo = data.card_type_info || [];
    },
  },
};
</script>
